<div class="card card-p2p-detail mb-3">
    <div class="card-body card-body--p2p">
        <div class="d-flex">
            <div class="d-block">
                <div class="position-relative mb-4">
                    <img style="border-radius: 5px" alt="P2P User Image" class="img-fluid rounded-start" [src]="imageDataUrl.value" style="width: 88px; min-height: 88px; border-radius: 4px;">
                    <app-input-file class="position-absolute custom-p2p-input-btn w-100" style="bottom:0;left:0" accept="image/png,image/jpeg" label="Edit" [formControl]="imageFile"></app-input-file>
                </div>
            </div>
            <div class="d-flex flex-column w-100 ml-4 mr-3">
                <div class="d-flex align-items-center justify-content-between">
                    <h5 class="subtitle-1--weight-regular mb-0 pb-1">{{data.displayName}}</h5>
                    <span class="body-2">{{createdByName()}}</span>
                </div>
                @if(data.teamInfo){
                    <div class="d-flex align-items-center justify-content-between">
                        <span class="body-1">{{data.teamInfo.name}}</span>
                        <span class="body-2">{{data.userInfo.email}}</span>
                    </div>
                    <div class="d-flex align-items-center justify-content-between">
                        <span class="body-2 grey-text">{{optionName()}}</span>
                        <span class="body-3 grey-text">Created On {{creationUnix() | date: 'MMM d, y'}}</span>
                    </div>
                } @else {
                    <div class="d-flex align-items-center justify-content-between">
                        <span class="body-2 grey-text">{{optionName()}}</span>
                        <span class="body-2">{{data.userInfo.email}}</span>
                    </div>
                    <div class="d-flex align-items-center justify-content-end">
                        <span class="body-3 grey-text">Created On {{creationUnix() | date: 'MMM d, y'}}</span>
                    </div>
                }
                <div class="row mt-auto">
                    <div class="col-4 mt-auto">
                        <div class="d-block">
                            <div class="d-block progress md-progress p2p-detail-progress">
                                <div 
                                    class="progress-bar active" role="progressbar"
                                    [attr.aria-valuenow]="progress()" aria-valuemin="0" aria-valuemax="100"
                                    [ngStyle]="progressNgStyle()">
                                </div>                                
                                <div class="progress-value text-center p2p-detail-progress--text">{{raised() | currency:'USD':'symbol-narrow':'1.0-0'}} of {{goal() | currency:'USD':'symbol-narrow':'1.0-0'}}</div>                                
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex mt-3 mb-n2 align-items-end">
                    <div class="mr-2" x-placement="bottom-end">                                
                        <app-p2p-link-popover [title]="'Donate Link'" [params] = "donateUrlParams"></app-p2p-link-popover>
                    </div>
                    <div class="mr-4" x-placement="bottom-end">                                
                        <app-p2p-link-popover [title]="'Fundraiser Link'" [params] = "fundraiserUrlParams"></app-p2p-link-popover>
                    </div>

                    <div class="d-flex align-items-end show ml-auto pr-2" x-placement="bottom-end">   
                        <span (click)="openP2pDetailModal('donations')" class="body-2 cursor--pointer mr-3" style="color: #0076FF;">{{donationsText()}}</span>
                    
                        @if (pledgePerEvent()) {
                            <span (click)="openP2pDetailModal('pledges')" class="body-2 cursor--pointer mr-4" style="color: #0076FF;">{{pledgesText()}}</span>
                        }

                        <app-p2p-details-popover [data] = "data" [campaignId]="data.campaignId"></app-p2p-details-popover>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>